/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  console.log("custom.js https://wren-digital.com");

 /**
 * Adds a shipping note under the price for both the One-Time Purchase
 * option and the Subscribe & Save option in the Appstle subscription widget.
 *
 * The note reads "+$5 shipping" by default, but switches to
 * "+ Free Shipping" whenever the currently selected product variant
 * carries the theme's "Free Shipping" option badge (e.g. the 24 Pack).
 *
 * This script:
 *  1. Polls until the Appstle widget container exists in the DOM.
 *  2. Inserts the note once found, and re-inserts it whenever Appstle
 *     re-renders the price blocks (it wipes/rebuilds them internally).
 *  3. Watches the variant selector for changes (radio click + the
 *     data-selected-variant JSON Shopify updates on every switch) and
 *     updates the note text to match the newly selected variant.
 *
 */
(function () {
  var DEFAULT_TEXT = '+$4.99 shipping';
  var FREE_SHIPPING_TEXT = '+ Free Shipping';
  var NOTE_CLASS = 'custom-shipping-note';

  // --- Determine current shipping text based on the selected variant ---

  function isFreeShippingSelected() {
    var checkedInput = document.querySelector(
      '.radio__buttons input[type="radio"]:checked'
    );
    if (!checkedInput) return false;

    var label = document.querySelector('label[for="' + checkedInput.id + '"]');
    if (!label) return false;

    var badge = label.querySelector('.option-badge');
    return !!(
      badge && badge.textContent.trim().toLowerCase().indexOf('free shipping') !== -1
    );
  }

  function currentShippingText() {
    return isFreeShippingSelected() ? FREE_SHIPPING_TEXT : DEFAULT_TEXT;
  }

  // --- Insert / update the note in the Appstle price blocks ---

  function makeNote() {
    var note = document.createElement('div');
    note.className = NOTE_CLASS;
    note.textContent = currentShippingText();
    return note;
  }

  function upsertShippingNotes() {
    var text = currentShippingText();
    var wrappers = document.querySelectorAll(
      '.appstle_one_time_price_wrapper, .appstle_subscription_amount_wrapper'
    );

    wrappers.forEach(function (wrapper) {
      var existing = wrapper.querySelector('.' + NOTE_CLASS);
      if (existing) {
        if (existing.textContent !== text) {
          existing.textContent = text;
        }
      } else {
        wrapper.appendChild(makeNote());
      }
    });
  }

  // --- Watch the variant selector for changes ---

  function watchVariantSelector() {
    var selectors = document.querySelector('.product__selectors');
    if (!selectors) return;

    // Radio click/change fires immediately on user interaction.
    selectors.addEventListener('change', function (e) {
      if (e.target && e.target.matches('input[type="radio"]')) {
        upsertShippingNotes();
      }
    });

    // Belt-and-suspenders: Shopify also rewrites the JSON script tag
    // holding the selected variant on every switch, so observe that too.
    var variantScript = document.querySelector(
      'variant-selects script[data-selected-variant]'
    );
    if (variantScript) {
      var scriptObserver = new MutationObserver(function () {
        upsertShippingNotes();
      });
      scriptObserver.observe(variantScript, {
        characterData: true,
        childList: true,
        subtree: true,
      });
    }
  }

  // --- Wait for the Appstle widget, then wire everything up ---

  function waitForWidget(attempts) {
    var widget = document.querySelector(
      '.appstle_sub_widget, [id^="appstle_subscription_widget"]'
    );

    if (widget) {
      upsertShippingNotes();
      watchVariantSelector();

      // Re-apply whenever Appstle re-renders (plan switch, frequency change, etc.)
      var observer = new MutationObserver(function () {
        upsertShippingNotes();
      });
      observer.observe(widget, { childList: true, subtree: true });
      return;
    }

    // Widget not in DOM yet — Appstle loads async. Keep polling briefly.
    if (attempts > 0) {
      setTimeout(function () {
        waitForWidget(attempts - 1);
      }, 200);
    }
  }

  function init() {
    waitForWidget(50); // ~10 seconds of polling before giving up
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
